import {Filter, FilterErrors, isContainerConcentrationFilter} from 'search/SearchConstants';

export default function validateContainerConcentrationFilters(filters: Array<Filter>): FilterErrors {
  return filters.map((filter) => {
    if (isContainerConcentrationFilter(filter)) {
      const {value, units} = filter.value;
      if (value == null && units == null) {
        // Don't error if it's just a blank filter, since we ignore those.
        return null;
      }
      if (value == null) {
        return 'Concentration value must be specified.';
      } else if (units == null) {
        return 'Concentration units must be specified.';
      }
    }
    return null;
  });
}
